/* eslint-disable */
import React, { useContext } from "react";
import { Button } from "./core/views/Button";
import ReactMarkdown from "react-markdown";
import { GlobalContext } from "./GlobalContext";
import "./server-error-page.scss";

interface ServerErrorPageProps {
  text: string;
}

export const ServerErrorPage: React.FC<ServerErrorPageProps> = ({ text }) => {
  const context = useContext(GlobalContext);

  return (
    <div className="big-content center-action">
      <div className="error-bot center-action" />
      <ReactMarkdown>{context?.api?.serverErrorStatusChecker?.serverDownError}</ReactMarkdown>
      <Button type="secondary" medium onClick={window.supportChat.open}>
        <span className="icon-speech-bubble" /> contact us
      </Button>
    </div>
  );
};
